import React, { FC, useState } from 'react';

import { Button, Card, CardContent, Typography, Box, Divider, Chip } from '@mui/material';

import DownloadIcon from '@mui/icons-material/Download';

import AuthorityProvidedFields from '../../waterAuthorityConfig/components/AuthorityProvidedFieldsDataEntry';
import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';

import { BackflowJobItem } from '../../model';

import axios from '../../../sharedModules/utils/axios.utils';

interface SubmissionPdfCardProps {
  item: BackflowJobItem;
}

const SubmissionPdfCard: FC<SubmissionPdfCardProps> = (props) => {
  const { item } = props;

  const [error, setError] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const downloadPdf = async (itemId: number, assetNo: string) => {
    setLoading(true);
    try {
      const response = await axios.get(`/backflows/water_authority_submissions/${itemId}/download_pdf`, {
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `water_authority_submission_${assetNo}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      setError(`Failed to download PDF for asset ${assetNo}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card elevation={2} sx={{ height: '100%' }}>
      <CardContent>
        <LoadingWrapper isLoading={loading}>
          <ErrorMessage message={error} />
          <Box display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
            <Typography variant="h6" fontWeight="600" color="primary">
              {item.asset_no}
            </Typography>
            <Chip
              label={item.status}
              color="success"
              size="small"
              sx={{ textTransform: 'uppercase', fontWeight: 600 }}
            />
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box sx={{ mb: 3 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              <strong>Location:</strong>
            </Typography>
            <Typography variant="body1" gutterBottom>
              {item.location || 'N/A'}
            </Typography>

            <Typography variant="body2" color="text.secondary" gutterBottom sx={{ mt: 1 }}>
              <strong>Device Type:</strong>
            </Typography>
            <Typography variant="body1">{item.device_type || 'N/A'}</Typography>
          </Box>

          <Divider />

          <AuthorityProvidedFields backflowJobItem={item} />
          <Divider sx={{ mb: 2 }} />
          <Button
            variant="contained"
            color="secondary"
            startIcon={<DownloadIcon />}
            onClick={() => downloadPdf(Number(item.id), item.asset_no)}
            fullWidth
            size="medium"
          >
            Download PDF
          </Button>
        </LoadingWrapper>
      </CardContent>
    </Card>
  );
};

export default SubmissionPdfCard;
